import {Pipe, PipeTransform} from '@angular/core';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import * as moment from 'moment-timezone';
import {filter, map, Observable, take} from 'rxjs';
import {UserTimezone} from '../main/signing-pages/signing-page/signing-page.dto';

@Pipe({ name: 'getTimezoneOffset' })

/*
 * returns the date formate using moment.js
 */
export class TimezoneOffsetPipe implements PipeTransform {
    private _userTimezone$ = this._sharedStoreFacade$.userTimezone$;
    constructor (private _sharedStoreFacade$: SharedStoreFacade) {}

 
    transform(): Observable<string> {
        return this._userTimezone$.pipe(
            filter(timeZone => Object.keys(timeZone)?.length > 0),
            take(1),
            map(userTimeZone => this.generateFormattedDate(userTimeZone))
          );
    }


    private generateFormattedDate(config: UserTimezone): string {
        const offset = moment.tz(config.timezone).format('Z'); // Get the offset in GMT
        return `${config.timezone} (GMT${offset})`;
    }
}
